<template>
  <el-time-picker v-if="spec.t === 'time'"
                  :name="_name"
                  v-model="value"
                  :placeholder="spec.placeholder"
                  :readonly="_readonly"
                  :disabled="_readonly"></el-time-picker>
  <el-date-picker v-else
                  :name="_name"
                  v-model="value"
                  :type="spec.t"
                  :placeholder="spec.placeholder"
                  :picker-options="{disabledDate: spec.disabledDate}"
                  :readonly="_readonly"
                  :disabled="_readonly"></el-date-picker>
</template>

<script>
  import mixin from './mixin';
  import {DatePicker, TimePicker} from 'element-ui';

  export default {
    name: 'f-datetime',
    mixins: [mixin],
    components: {
      [DatePicker.name]: DatePicker,
      [TimePicker.name]: TimePicker,
    },
  };
</script>



// WEBPACK FOOTER //
// f-datetime.vue?ee75afd8